import { render, staticRenderFns } from "./RoleEditorView.vue?vue&type=template&id=4944805d&scoped=true"
import script from "./RoleEditorView.vue?vue&type=script&lang=js"
export * from "./RoleEditorView.vue?vue&type=script&lang=js"
import style0 from "./RoleEditorView.vue?vue&type=style&index=0&id=4944805d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944805d",
  null
  
)

export default component.exports